import './assets/styles/main.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';

import * as Sentry from '@sentry/vue';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

const useSentry =
    import.meta.env.VITE_APP_MODE === 'production' || import.meta.env.VITE_APP_MODE === 'testing';

if (useSentry) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true
            })
        ]
    });
    pinia.use(Sentry.createSentryPiniaPlugin());
}

app.mount('#app');
